import { Tag } from '@hub/shared'
import { RecruitmentScope } from '@hub/shared/interfaces/user-in-campaign.interface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import './content-by-profile.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  scope: RecruitmentScope
  title?: string
}

export default ({ scope, title = '', className = '', ...props }: Props) => {
  const { t } = useTranslation('contentByProfile')
  const iconsMapped = {
    contents: 'fa-file-alt',
    posts: 'fa-image-polaroid',
    reels: 'fa-film',
    stories: 'fa-rectangle-vertical-history',
  }
  return (
    scope &&
    ((scope?.requiredContent && Object?.values(scope?.requiredContent)?.some((value) => !!value)) ||
      (scope?.suggestedContent && Object?.values(scope?.suggestedContent)?.some((value) => !!value))) && (
      <section className={`content-by-profile ${className}`} {...props}>
        <h5 className="title">{title || t('title')}</h5>
        {!scope?.publishedOnSocialMedia ? (
          <div className="main-content">
            <Tag
              icon={<i className="fa-light fa-browser"></i>}
              labels={[t('publicationLabel'), <strong style={{ fontSize: '0.9rem' }}>{t('publicationValue')}</strong>]}
              separator
            />
          </div>
        ) : null}
        {scope?.requiredContent &&
        Object?.values(scope?.requiredContent)?.length &&
        Object?.values(scope?.requiredContent)?.some((value) => !!value) ? (
          <div className="minimum-required-content mt-3">
            <h6 className="subtitle">{t('mandatoryMinimum')}</h6>
            <div className="tags">
              {Object.entries(scope?.requiredContent).map(([key, count]) =>
                count ? (
                  <Tag key={key} icon={<i className={`fa-light ${iconsMapped[key]}`}></i>} labels={[t(`fields.${key}`, { count })]} />
                ) : null
              )}
            </div>
          </div>
        ) : null}
        {scope?.suggestedContent &&
        Object?.values(scope?.suggestedContent)?.length &&
        Object?.values(scope?.suggestedContent)?.some((value) => !!value) ? (
          <div className="minimum-suggested-content mt-3">
            <h6 className="subtitle">{t('suggestedMinimum')}</h6>
            <div className="tags">
              {Object.entries(scope?.suggestedContent).map(([key, count]) =>
                count ? (
                  <Tag key={key} icon={<i className={`fa-light ${iconsMapped[key]}`}></i>} labels={[t(`fields.${key}`, { count })]} />
                ) : null
              )}
            </div>
          </div>
        ) : null}
      </section>
    )
  )
}
